import { isNumber } from "lodash";
import {
  ICourse,
  IFieldSystem,
  IFieldSystemAlert,
  IFieldSystemData,
  IGolfBroadcastSystem,
  IHole,
  IPTU,
  ISystemData,
} from "../interfaces";
import {
  MarkerSeverity,
  MarkerType,
  compareMarkerSeverityPriority,
} from "../enums";

const defaultMarkerType = MarkerSeverity.Unknown;

export const convertFieldSystemsToSystemMarker = (
  fields: IFieldSystem[],
  tscUrl: string
): ISystemData[] => {
  var systemMarkers: ISystemData[] = [];

  fields.forEach((field: IFieldSystem) => {
    var fieldMarkerType = defaultMarkerType;
    var fieldAlertDescriptions: string[] = [];

    //Get links
    const createTicketLink = "https://trackman.zendesk.com/agent/tickets/new/1";

    const stadium = "STADIUM";
    const stadiumLink =
      "https://trackman.visualstudio.com/Baseball%20Stadium%20v3/_backlogs/backlog/Baseball%20Stadium%20v3%20Team/Backlog%20items";
    const backfield = "BACKFIELD";
    const backfieldLink =
      "https://trackman.visualstudio.com/Baseball%20Backfield%20v3/_backlogs/backlog/Baseball%20Backfield%20v3%20Team/Backlog%20items";
    var createWorkItemLink = "";
    var createSystemLink = "";

    //Check fields for systems
    field.systems?.map((fieldSystem: IFieldSystemData) => {
      //Find the highest level of severity among alerts
      var markerType: MarkerSeverity | undefined = fieldSystem.alerts?.reduce(
        (acc: MarkerSeverity, current: IFieldSystemAlert): MarkerSeverity => {
          if (current?.status && current.status !== "resolved") {
            return compareMarkerSeverityPriority(acc, current.severity);
          }
          return acc;
        },
        MarkerSeverity.Normal
      );
      if (markerType === undefined) markerType = MarkerSeverity.Unknown;
      fieldMarkerType = markerType;

      //Get all Error Descriptions
      if (fieldSystem.alerts) {
        var alertDescriptions =
          markerType === MarkerSeverity.Unknown ||
          markerType === MarkerSeverity.Normal
            ? []
            : fieldSystem.alerts.map((alert) => {
                return String(alert.description);
              });

        fieldAlertDescriptions =
          fieldAlertDescriptions.concat(alertDescriptions);
      }

      if (!createWorkItemLink)
        createWorkItemLink = fieldSystem.systemType
          ?.toUpperCase()
          .includes(stadium)
          ? stadiumLink
          : fieldSystem.systemType?.toUpperCase().includes(backfield)
          ? backfieldLink
          : "";

      createSystemLink = tscUrl + "systems/" + fieldSystem.systemId;
    });

    //Making a SystemMarker Object for each system in each Field, with current available data
    var newSystemMarker: ISystemData = {
      id: field.fieldId,
      name: field.fieldName ? String(field.fieldName) : field.fieldId,
      type: field.type === "Baseball" ? MarkerType.BASEBALL : MarkerType.SOFTBALL,
      status: {
        statusType: fieldMarkerType,
        errors: fieldAlertDescriptions,
        heartbeat: null,
        gameInProgress: false,
        needRerender: false,
      },
      position: {
        lat: field.fieldLatitude,
        lng: field.fieldLongitude,
        address: null,
        city: field.city ? field.city : null,
        country: null,
        state: field.state ? field.state : null,
        GroupID: field.fieldId,
      },
      links: {
        createTicket: createTicketLink,
        systemDetails: createSystemLink,
        sysOwnerContact: "",
        createWorkItem: createWorkItemLink,
      },
    };

    systemMarkers.push(newSystemMarker);
  });

  return systemMarkers;
};

export const convertGolfBroadcastToSystemMarkers = (
  golfBroadcast: IGolfBroadcastSystem
): ISystemData[] => {
  var systemMarkers: ISystemData[] = [];
  golfBroadcast.courses?.forEach((course: ICourse) => {
    course.holes?.forEach((hole: IHole) => {
      hole.ptUs?.forEach((ptu: IPTU) => {
        var systemname =
          (golfBroadcast.tournamentName
            ? String(golfBroadcast.tournamentName)
            : golfBroadcast.tournamentId) +
          " | " +
          (isNumber(hole.holeNumber) ? "Hole " + hole.holeNumber : "Hole ?") +
          " | " +
          (ptu.type ? ptu.type : "Unknown Systemtype");

        var newSystemMarker: ISystemData = {
          id: course.courseId + "_" + hole.holeNumber + "_" + ptu.type,
          name: systemname,
          type: MarkerType.GOLF_BROADCAST,
          status: {
            statusType: MarkerSeverity.Unknown,
            errors: [],
            heartbeat: null,
            gameInProgress: false,
            needRerender: false,
          },
          position: {
            lat: ptu.latitude,
            lng: ptu.longitude,
            address: null,
            city: golfBroadcast.city ? golfBroadcast.city : null,
            country: null,
            state: golfBroadcast.state ? golfBroadcast.state : null,
            GroupID: golfBroadcast.tournamentId,
          },
          links: {
            createTicket: "",
            systemDetails: "",
            sysOwnerContact: "",
            createWorkItem: "",
          },
        };
        systemMarkers.push(newSystemMarker);
      });
    });
  });

  return systemMarkers;
};

export const convertGolfBroadcastSystemsToSystemMarkers = (
  golfBroadcastSystems: IGolfBroadcastSystem[]
): ISystemData[] => {
  var systemMarkers: ISystemData[] = [];
  golfBroadcastSystems.forEach((golfBroadcast: IGolfBroadcastSystem) => {
    systemMarkers.concat(convertGolfBroadcastToSystemMarkers(golfBroadcast));
  });

  return systemMarkers;
};
